import { render, staticRenderFns } from "./SelectSupervisorCollaborator.vue?vue&type=template&id=65dd8051&scoped=true&"
import script from "./SelectSupervisorCollaborator.vue?vue&type=script&lang=js&"
export * from "./SelectSupervisorCollaborator.vue?vue&type=script&lang=js&"
import style0 from "./SelectSupervisorCollaborator.vue?vue&type=style&index=0&id=65dd8051&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dd8051",
  null
  
)

export default component.exports